import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=589faaf1&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=589faaf1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589faaf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589faaf1')) {
      api.createRecord('589faaf1', component.options)
    } else {
      api.reload('589faaf1', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=589faaf1&scoped=true", function () {
      api.rerender('589faaf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorFinal/Upload.vue"
export default component.exports